export const breakPoint = 1024;
export const specialChars = new RegExp(/[#!@$%^*]/);

export const headerId: string = "winpay-header";
export const sidebarId: string = "winpay-sidebar";
export const breadcrumbId: string = "winpay-breadcrumb";
export const bottombarId: string = "winpay-bottombar";
export const bodyId: string = "winpay-body";
export const loaderId: string = "winpay-loader";
export const messageId: string = "winpay-message";
export const modalId: string = "winpay-modal";
